var React = require('react');

function DecorLeftBottom (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1 0V32H70","stroke":"#FCB34E"}));
}

DecorLeftBottom.defaultProps = {"width":"70","height":"33","viewBox":"0 0 70 33","fill":"none"};

module.exports = DecorLeftBottom;

DecorLeftBottom.default = DecorLeftBottom;



//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-react-loader/lib/loader.js!./src/icons/decor-left-bottom.svg
// module id = 1047
// module chunks = 0